import Component from './Search';

export default Component;
